"use client";

function getLuOddsColor(_green, trend) {
  const t = trend === "up" ? "increased" : trend === "down" ? "decreased" : trend;
  if (t === "decreased") return "text-lu-odds-down kbv-gs-odds-down";
  if (t === "increased") return "text-lu-odds-up kbv-gs-odds-up";
  return "text-[var(--theme-text)]";
}

function normalizeTrend(trend) {
  if (trend === "up") return "increased";
  if (trend === "down") return "decreased";
  return trend ?? "unchanged";
}

export function LuTrendArrow({ trend, isMobile = false }) {
  const t = normalizeTrend(trend);
  const isTrend = t === "increased" || t === "decreased";
  if (!isTrend) return null;
  const statusClass = t === "increased" ? "lu-odds-status--up" : isTrend ? "lu-odds-status--down" : "";

  return (
    <span
      className={`shrink-0 inline-block ${isMobile ? "w-2 h-2" : "w-[10px] h-[10px]"} ${statusClass}`}
      aria-hidden
    />
  );
}

export default function LuOddsItem({
  title,
  left,
  middle,
  right,
  leftGreen = false,
  middleGreen = false,
  rightGreen = false,
  leftTrend = "unchanged",
  middleTrend = "unchanged",
  rightTrend = "unchanged",
  tagText = "",
  tagColorClass = "bg-slate-500",
}) {
  return (
    <div className="flex flex-col gap-y-0.5 md:min-w-auto md:shrink-0 md:gap-y-1 box-border">
      <div className="flex items-center justify-center text-[12px] font-bold md:hidden box-border">{title}</div>
      <div className={`kbv-lu-odds-box flex relative h-6 w-full min-w-0 items-center justify-between gap-0 rounded bg-[#f6f7fa] px-1 text-xs font-normal text-[var(--theme-text)] md:h-9 md:gap-1 md:px-0.5 md:w-[152px] md:text-sm box-border ${tagText ? "md:mt-3.5" : ""}`}>
        {tagText && (
          <div className={`max-md:hidden absolute -top-[14px] right-0 kbv-tag-base ${tagColorClass} opacity-100 z-10`}>
            {tagText}
          </div>
        )}
        <span className={`flex min-w-0 flex-1 items-center justify-center gap-0 font-semibold ${getLuOddsColor(leftGreen, leftTrend)} md:min-w-[44px] md:gap-0.5`}>
          {left}
          <LuTrendArrow trend={leftTrend} />
        </span>
        <span className={`flex min-w-0 flex-1 items-center justify-center gap-0 font-medium ${getLuOddsColor(middleGreen, middleTrend)} md:min-w-[44px] md:gap-0.5`}>
          {middle}
          <LuTrendArrow trend={middleTrend} />
        </span>
        <span className={`flex min-w-0 flex-1 items-center justify-center gap-0 font-medium ${getLuOddsColor(rightGreen, rightTrend)} md:min-w-[44px] md:gap-0.5`}>
          {right}
          <LuTrendArrow trend={rightTrend} />
        </span>
      </div>
    </div>
  );
}
